if(!customElements.get('card-quick-buy')) {
  customElements.define(
    'card-quick-buy',
    class CardQuickBuy extends HTMLElement {

      constructor() {
        super();

        this.miniCart = document.querySelector('mini-cart');

        this.addEventListener('change', this.onVariantChange);

        this.updateOptions();
        this.updateMasterId();
        this.setAvailability();
        this.setEnforcementAvailability();
      }

      onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();

        if (!this.currentVariant) {
          this.setAvailabilityInUnavailable();
        } else {
          this.setAvailability();
          document.dispatchEvent(new CustomEvent('variant:change', {
            detail: {
              variant: this.currentVariant
            }
          }));

          const enforcementBlocked = this.getEnforcementBlocked();
          if (enforcementBlocked !== null) {
            const blocked = enforcementBlocked[String(this.currentVariant.id)];
            if (blocked === true) {
              // Variant is enforcement-blocked — block add to cart, show sold-out feedback
              const input = event.target;
              input.setAttribute('data-crossout', '');
              input.checked = false;
              document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                detail: { errorMessage: (window.theme && theme.variantStrings && theme.variantStrings.soldOut) || 'Sold out' }
              }));
              return;
            }
          }

          this.addVariantToCart(event);
        }
      }

      updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
          return (fieldset.querySelectorAll('input:checked').length > 0) ? Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value : false;
        });
      }

      updateMasterId() {
        if(!this.options) return;
        this.currentVariant = this.getVariantData()?.find((variant) => {
          return !variant.options.map((option, index) => {
            return this.options[index] === option;
          }).includes(false);
        });
      }

      addVariantToCart(event) {        
        if (document.body.classList.contains('template-cart') || !theme.shopSettings.cartDrawer) {
          Shopify.postLink(theme.routes.cart_add_url, {
            parameters: {
              id: this.currentVariant.id,
              quantity: 1
            },
          });
          return;
        }

        let input = event.target;
        input.setAttribute('disabled', true);
        input.classList.add('loading');

        const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];

        const body = JSON.stringify({
          id: this.currentVariant.id,
          quantity: 1,
          sections: sections,
          sections_url: window.location.pathname
        });

        fetch(`${theme.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status === 422) {
             document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                detail: {
                  errorMessage: parsedState.description
                }
              }));
           }
           else {
            this.miniCart && this.miniCart.renderContents(parsedState);

             document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: {
                product: parsedState
              }
            }));
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          input.classList.remove('loading');
          input.removeAttribute('disabled');
          input.checked = false;
        });
      }

      getEnforcementBlocked() {
        const el = this.querySelector('[data-enforcement-blocked]');
        if (!el) return null;
        try {
          return JSON.parse(el.textContent);
        } catch (e) {
          return null;
        }
      }

      setEnforcementAvailability() {
        const enforcementBlocked = this.getEnforcementBlocked();
        if (!enforcementBlocked) return;

        const variants = this.getVariantData();

        this.querySelectorAll('fieldset').forEach(fieldset => {
          const optionIndex = fieldset.dataset.optionIndex; // e.g. "option1"
          fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
            const matchingVariants = variants.filter(v => v[optionIndex] === input.value);
            const allBlocked = matchingVariants.length > 0 && matchingVariants.every(v => {
              const blocked = enforcementBlocked[String(v.id)];
              return blocked === true;
            });
            if (allBlocked) {
              input.setAttribute('data-crossout', '');
              input.disabled = true;
            }
          });
        });
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      setAvailability() {
        if (!this.currentVariant) return;
        this.querySelectorAll('fieldset').forEach(group => {
          this.disableVariantGroup(group);
        });
    
        const currentlySelectedValues = this.currentVariant.options.map((value,index) => {return {value, index: `option${index+1}`}})
        const initialOptions = this.createAvailableOptionsTree(this.variantData, currentlySelectedValues, this.currentVariant);
    
        for (var [option, values] of Object.entries(initialOptions)) {
          this.manageOptionState(option, values);
        }
      }

      setAvailabilityInUnavailable() {
        this.querySelectorAll('fieldset').forEach(group => {
          this.disableVariantGroup(group);
        });
    
        const currentlySelectedValues = this.options.map((value,index) => {return {value, index: `option${index+1}`}})
        const initialOptions = this.createAvailableOptionsTree(this.variantData, currentlySelectedValues, this.currentVariant);
    
        for (var [option, values] of Object.entries(initialOptions)) {
          this.manageOptionState(option, values);
        }
      }

      enableVariantOption(group, obj) {
        const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
        const input = group.querySelector('input[value="'+ value +'"]');
    
        // Variant exists - enable & show variant
        input.removeAttribute('disabled');
        input.checked = false;
    
        // Variant sold out - cross out option (remains selectable)
        if (obj.soldOut) {
          input.setAttribute('disabled', '');
          input.classList.add('disabled');
        }
      }

      disableVariantGroup(group) {
        group.querySelectorAll('input').forEach((input) => {
          input.setAttribute('disabled', '');
        });
      }

      manageOptionState(option, values) {
        const group = this.querySelector('fieldset[data-option-index="'+ option +'"]');
    
        // Loop through each option value
        values.forEach(obj => {
          this.enableVariantOption(group, obj);
        });
      }

      createAvailableOptionsTree(variants, currentlySelectedValues) {
        // Reduce variant array into option availability tree
        return variants.reduce((options, variant) => {
    
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach(index => {
    
            if (variant[index] === null) return;
    
            let entry = options[index].find(option => option.value === variant[index]);
    
            if (typeof entry === 'undefined') {
              // If option has yet to be added to the options tree, add it
              entry = {value: variant[index], soldOut: true}
              options[index].push(entry);
            }
    
            const currentOption1 = currentlySelectedValues.find(({value, index}) => index === 'option1')
            const currentOption2 = currentlySelectedValues.find(({value, index}) => index === 'option2')
    
            switch (index) {
              case 'option1':
                // Option1 inputs should always remain enabled based on all available variants
                entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                break;
              case 'option2':
                // Option2 inputs should remain enabled based on available variants that match first option group
                if (currentOption1 && variant['option1'] === currentOption1.value) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
              case 'option3':
                // Option 3 inputs should remain enabled based on available variants that match first and second option group
                if (
                  currentOption1 && variant['option1'] === currentOption1.value
                  && currentOption2 && variant['option2'] === currentOption2.value
                ) {
                  entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                }
            }
          })
    
          return options;
        }, { option1: [], option2: [], option3: []})
      }
    }
  );
}